function sub(n, r, t) {
  var e = new Array(t);
  var u = 0;
  var a = r;
  while (u < t) {
    e[u] = n[a];
    u = u + 1 | 0;
    a = a + 1 | 0;
  }
  return e;
}

function app(n, r) {
  while (1) {
    var t = r;
    var e = n;
    var u = e.length;
    var a = 0 === u ? 1 : u;
    var c = a - t.length | 0;
    if (0 === c) {
      return e.apply(null, t);
    }
    if (c >= 0) {
      return function(n, r) {
        return function(t) {
          return app(n, r.concat([ t ]));
        };
      }(e, t);
    }
    r = sub(t, a, 0 | -c);
    n = e.apply(null, sub(t, 0, a));
  }
}

function _1(n, r) {
  var t = n.length;
  if (1 === t) {
    return n(r);
  } else {
    switch (t) {
     case 1:
      return n(r);

     case 2:
      return function(t) {
        return n(r, t);
      };

     case 3:
      return function(t, e) {
        return n(r, t, e);
      };

     case 4:
      return function(t, e, u) {
        return n(r, t, e, u);
      };

     case 5:
      return function(t, e, u, a) {
        return n(r, t, e, u, a);
      };

     case 6:
      return function(t, e, u, a, c) {
        return n(r, t, e, u, a, c);
      };

     case 7:
      return function(t, e, u, a, c, i) {
        return n(r, t, e, u, a, c, i);
      };

     default:
      return app(n, [ r ]);
    }
  }
}

function __1(n) {
  if (1 === n.length) {
    return n;
  } else {
    return function(r) {
      return _1(n, r);
    };
  }
}

var n = {
  contents: 0
};

function create(r) {
  n.contents = n.contents + 1 | 0;
  return r + "/" + n.contents;
}

function is_extension(n) {
  if (null == n) {
    return !1;
  } else {
    return "string" == typeof n.RE_EXN_ID;
  }
}

export { __1 as _, _1 as a, create as c, is_extension as i };
